import { useEffect } from 'react';
import gsap from 'gsap';
import { ScrollTrigger } from 'gsap/ScrollTrigger';
import Breadcrumbs from 'components/Breadcrumbs';
import { Button } from 'components/buttons/Button/Button';
import './styles.scss';

const Banner = ({
    title = '',
    image,
    buttonText,
    buttonType = 'learn-more',
    children = undefined,
    withCrumbs = true,
}) => {
    useEffect(() => {
        gsap.registerPlugin(ScrollTrigger);

        gsap.to('.bg', {
            scrollTrigger: {
                trigger: '.bg',
                start: 'top top',
                end: 'bottom top',
                scrub: true,
                onUpdate: self => {
                    const scrollPercentage = self.progress * 20;
                    gsap.to('.bg', { yPercent: scrollPercentage });
                },
            },
        });
    }, []);
  
    return (
        <section className="container">
            <div className="primary-section-wrapper">
                <div className="primary-section">
                    <div className="left-side">
                        {withCrumbs && <Breadcrumbs />}
                        {title ? <h2>{title}</h2> : <div className="left-side__content">{children}</div>}
                    </div>
                    <div className="button-wrapper">
                        <Button type={buttonType}>{buttonText}</Button>
                        <div className="smooth-corner1"></div>
                        <div className="smooth-corner2"></div>
                    </div>
                </div>
                <img className="bg" src={image} alt={title} />
            </div>
            {buttonType.includes('find') && (
                <Button type="find-mobile" className="banner-bottom">
                    {buttonText}
                </Button>
            )}
            {buttonType.includes('banner') && <Button className="banner-bottom">{buttonText}</Button>}
        </section>
    );
};
export default Banner;
